import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';

import axios from "axios";
import {getOktaAccessToken, getOktaIdToken, checkAuthentication, logout} from "./shared/okta.helper";

import AppContextProvider from "./contexts/App/App.provider";

const MOUNT_NODE = document.getElementById('app');

const render = () => {
    ReactDOM.render(
        <AppContextProvider checkAuthentication={checkAuthentication} logout={logout}>
            <App/>
        </AppContextProvider>,
        MOUNT_NODE
    );
};
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
    render();
}

axios.interceptors.request.use((config) => {
    const oktaIdToken = getOktaIdToken();
    const oktaAccessToken = getOktaAccessToken();
    const interceptedConfig = config;
    interceptedConfig.headers = config.headers || {};
    if (oktaIdToken && oktaAccessToken) {
        interceptedConfig.headers.Authorization = `Bearer ${oktaAccessToken}`;
    }

    return interceptedConfig;
}, (error) => Promise.reject(error));

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
    (new Promise((resolve) => {
      resolve(import('intl'));
    }))
    .then(() => Promise.all([
        import('intl/locale-data/jsonp/en.js'),
    ]))
    .then(() => render())
    .catch((err) => {
        throw err;
    });
}
else {
    render();
}